import React from 'react';
import dateHelper from '../../util/dateHelper';
import FooterLogo from './FooterLogo';
import { LinkV2 } from '../LinkV2';
import SocialIcons from './SocialIcons';

const SocialAndTerms = (): JSX.Element => {
  const year = dateHelper.getFullYear();
  return (
    <div className="common-footer__social-and-terms">
      <div className="zola-logo">
        <FooterLogo />
      </div>
      <div className="tagline">For all the days along the way</div>
      <SocialIcons />
      <div className="hashtag">@ZOLA</div>
      <div className="copyright">
        &copy; <span className="date">{year}</span> Zola, Inc. All rights reserved.
      </div>
      <ul className="terms-links">
        <li>
          <LinkV2 href="/privacy" target="_blank" rel="noopener noreferrer" subtle noUnderline>
            Privacy Policy
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/terms" target="_blank" rel="noopener noreferrer" subtle noUnderline>
            Terms of Use
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/webaccessibility" target="_self" subtle noUnderline>
            Web Accessibility
          </LinkV2>
        </li>
        <li>
          <LinkV2
            href="/privacy-center"
            target="_blank"
            rel="noopener noreferrer"
            subtle
            noUnderline
          >
            Do Not Sell or Share My Personal Information
          </LinkV2>
        </li>
      </ul>
    </div>
  );
};

export default SocialAndTerms;
